import React, { useState } from "react";
import useSettingEvalItems from "../../../../hooks/useSettingEvalItems";
import { useUIContext } from "../../../../context/UIContext";
import { useTranslation } from "react-i18next";
import { arrangeDataByHierarchy } from "../../../../util/specialCase";

export default function RubricDrawer({
  item,
  onClose,
  getEvalItemsByLessonId,
  setEvalItemsData,
}) {
  const { t } = useTranslation();
  const { updateEvalItems } = useSettingEvalItems();
  const { handleToastCenterTop } = useUIContext();
  const [isSaving, setIsSaving] = useState(false);

  const [rubricData, setRubricData] = useState({
    standard: item?.extra_data?.rubric?.standard || "",
    3: item?.extra_data?.rubric?.["3"] || "",
    2: item?.extra_data?.rubric?.["2"] || "",
    1: item?.extra_data?.rubric?.["1"] || "",
    method: item?.extra_data?.rubric?.method || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRubricData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSaving(true);

    const updatedItem = {
      ...item,
      extra_data: {
        ...item.extra_data,
        rubric: rubricData,
      },
    };

    const forWhere = {
      schoolid: item.schoolid,
      lesson_id: item.lesson_id,
    };

    updateEvalItems.mutate(updatedItem, {
      onSuccess: (successMessage) => {
        console.log(successMessage);
        setIsSaving(false);
        handleToastCenterTop(
          t("common.messages.savedSuccessfully") || "성공적으로 저장되었습니다."
        );

        // 데이터 새로고침
        getEvalItemsByLessonId.mutate(forWhere, {
          onSuccess: (data) => {
            const processedData = arrangeDataByHierarchy([...data]);
            setEvalItemsData(processedData);
            onClose();
          },
          onError: (error) => {
            console.error(error);
            handleToastCenterTop(
              t("common.messages.errorAlert") + error.message
            );
          },
        });
      },
      onError: (error) => {
        setIsSaving(false);
        console.error(error);
        handleToastCenterTop(t("common.messages.errorAlert") + error.message);
      },
    });
  };

  return (
    <>
      {/* 백드롭 */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 9998,
        }}
        onClick={onClose}
      />

      {/* Drawer 패널 */}
      <div
        style={{
          position: "fixed",
          right: 0,
          top: 0,
          width: "700px",
          height: "100vh",
          backgroundColor: "white",
          boxShadow: "-4px 0 15px rgba(0, 0, 0, 0.2)",
          zIndex: 9999,
          overflowY: "auto",
          animation: "slideIn 0.3s ease-out",
        }}
      >
        <div style={{ padding: "20px" }}>
          {/* 헤더 */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4>{t("teacher.lessonRelated.rubric") || "루브릭"}</h4>
            <button className="btn btn-secondary" onClick={onClose}>
              {t("common.labels.close") || "닫기"}
            </button>
          </div>
          {/* 루브릭 입력 폼 */}
          <form onSubmit={handleSubmit}>
            <table
              className="table table-bordered"
              style={{ tableLayout: "fixed" }}
            >
              <thead className="table-light">
                <tr>
                  <th style={{ width: "90px" }} className="text-center">
                    평가항목
                  </th>
                  <th className="text-center">{item?.content}</th>
                </tr>
              </thead>
              <tbody>
                {/* 성취기준 */}
                <tr>
                  <td className="text-center align-middle fw-bold">성취기준</td>
                  <td className="p-2">
                    <textarea
                      className="form-control"
                      name="standard"
                      value={rubricData.standard}
                      onChange={handleChange}
                      rows={4}
                      placeholder="성취기준을 입력하세요"
                      style={{ resize: "vertical" }}
                    />
                  </td>
                </tr>

                {/* 평가기준 */}
                <tr>
                  <td
                    className="text-center align-middle fw-bold"
                    rowSpan={3}
                    style={{ verticalAlign: "middle" }}
                  >
                    평가기준
                  </td>
                  <td className="p-0">
                    <div className="d-flex">
                      <div
                        className="text-center align-middle p-2 fw-bold bg-light"
                        style={{
                          width: "90px",
                          borderRight: "1px solid #dee2e6",
                        }}
                      >
                        매우잘함
                      </div>
                      <div className="flex-grow-1 p-2">
                        <textarea
                          className="form-control border-0"
                          name="3"
                          value={rubricData["3"]}
                          onChange={handleChange}
                          rows={3}
                          placeholder="매우잘함 기준을 입력하세요"
                          style={{ resize: "vertical" }}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="p-0">
                    <div className="d-flex">
                      <div
                        className="text-center align-middle p-2 fw-bold bg-light"
                        style={{
                          width: "90px",
                          borderRight: "1px solid #dee2e6",
                        }}
                      >
                        잘함
                      </div>
                      <div className="flex-grow-1 p-2">
                        <textarea
                          className="form-control border-0"
                          name="2"
                          value={rubricData["2"]}
                          onChange={handleChange}
                          rows={3}
                          placeholder="잘함 기준을 입력하세요"
                          style={{ resize: "vertical" }}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="p-0">
                    <div className="d-flex">
                      <div
                        className="text-center align-middle p-2 fw-bold bg-light"
                        style={{
                          width: "90px",
                          borderRight: "1px solid #dee2e6",
                        }}
                      >
                        보통
                      </div>
                      <div className="flex-grow-1 p-2">
                        <textarea
                          className="form-control border-0"
                          name="1"
                          value={rubricData["1"]}
                          onChange={handleChange}
                          rows={3}
                          placeholder="보통 기준을 입력하세요"
                          style={{ resize: "vertical" }}
                        />
                      </div>
                    </div>
                  </td>
                </tr>

                {/* 평가 내용 및 방법 */}
                <tr>
                  <td className="text-center align-middle fw-bold">
                    평가 내용 및 방법
                  </td>
                  <td className="p-2">
                    <textarea
                      className="form-control"
                      name="method"
                      value={rubricData.method}
                      onChange={handleChange}
                      rows={4}
                      placeholder="평가 내용 및 방법을 입력하세요"
                      style={{ resize: "vertical" }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            {/* 버튼 */}
            <div className="d-flex gap-2 justify-content-end mt-4">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={isSaving}
              >
                {t("common.labels.cancel") || "취소"}
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSaving}
              >
                {isSaving
                  ? (t("common.status.saving") || "저장중") + "..."
                  : t("common.labels.save") || "저장"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* CSS 애니메이션 */}
      <style jsx>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }
      `}</style>
    </>
  );
}
